// DashboardDetails.tsx
import { useEffect, useState } from "react";
import Sidebar from '../components/SideBar';
import FiltrosDashboard from '../components/FiltrosDashboard';
import PlanoSelector from '../components/PlanoSelector';
import CardIndicatorSecondary from '../components/dashboardPages/CardIndicatorSecondary';
import GaugeDashboard from '../components/dashboard/GaugeDashboard'; 
import VGVDashboard from '../components/dashboard/VGVDashboard';
import ProdutoDashboard from '../components/dashboard/ProdutoDashboard'; 
import BarLateralIntervalos from '../components/dashboard/BarLateralIntervalos';
import FaseDashboard from '../components/dashboard/FaseDashboard';
import EvolucaoDashboard from '../components/dashboard/EvolucaoDashboard';
import GraficoBar from '../components/dashboard/PrecoDashboard';
import CardRanking from "../components/dashboard/CardRanking";
import { MapPin, Building2, Building, Globe, Hammer, BriefcaseBusiness } from 'lucide-react';
import { authService } from "../API/auth";
import type { Plano } from "../components/PlanoSelector";

import '../styles/dashboardStyle/Dashboard.css';
import '../styles/dashboardPagesStyle/Charts.css';
import '../styles/dashboardPagesStyle/CardVGV.css';
import CardUnidades from '../components/dashboard/CardUnidades';

import { 
  getVGVDashboard, 
  MesValor, 
  getEstoquePorTipo, 
  EstoquePorTipo, 
  getEstoquePorFase, 
  EstoquePorFase, 
  getPercentualVendido, 
  getIntervalosArea, 
  getPrecoMedioM2PorIntervaloVendas,
  getPrecoMedioM2PorIntervaloArea,
  IntervaloQuantidade,
  getPrecoMedioPorMes,
  getPrecoMedioM2PorMes,
  PrecoMedioMes,
  getEvolucaoVendas,
  EvolucaoVendasItem,
  getItensPorCategoria,
  getUnidadesDashboard, 
  UnidadesDashboard,
  IndicadoresDashboardDetalhado,
  getIndicadoresDashboardDetalhado
} from "../API/dashboardDetailsService";


export default function DashboardDetails() {
  const [planosSelecionados, setPlanosSelecionados] = useState<Plano[]>([]);
  const [planosDisponiveis, setPlanosDisponiveis] = useState<Plano[]>([]);
  const [mostrarBotaoRelatorio, setMostrarBotaoRelatorio] = useState(true);

  const planoAtual = planosSelecionados.length > 0 
  ? planosSelecionados[0] 
  : null;

  const [filtros, setFiltros] = useState<any>({});
  const [vgvData, setVgvData] = useState<MesValor[]>([]);
  const [estoquePorTipo, setEstoquePorTipo] = useState<EstoquePorTipo>({
    Lote: 0,
    Apartamento: 0,
    Comercial: 0,
    Casa: 0,
    Compacto: 0,
  });
  const [precoMedioData, setPrecoMedioData] = useState<PrecoMedioMes[]>([]);
  const [precoMedioM2Data, setPrecoMedioM2Data] = useState<PrecoMedioMes[]>([]);
  const [evolucaoVendasData, setEvolucaoVendasData] = useState<EvolucaoVendasItem[]>([]);
  const [precoM2VendasData, setPrecoM2VendasData] = useState<IntervaloQuantidade[]>([]);
  const [precoM2AreaData, setPrecoM2AreaData] = useState<IntervaloQuantidade[]>([]);
  const [vendidoData, setVendidoData] = useState<IntervaloQuantidade[]>([]);
  const [areaData, setAreaData] = useState<IntervaloQuantidade[]>([]);
  const [lazerData, setLazerData] = useState<{ nome: string; valor: number }[]>([]);
  const [infraestruturaData, setInfraestruturaData] = useState<{ nome: string; valor: number }[]>([]);
  const [segurancaData, setSegurancaData] = useState<{ nome: string; valor: number }[]>([]);
  const [estoquePorFase, setEstoquePorFase] = useState<EstoquePorFase>({
    Planta: 0,
    Obra: 0,
    Pronto: 0,
  });

  const [unidadesData, setUnidadesData] = useState<UnidadesDashboard>({
    tipologia: { estoque: {}, vendidas: {}, ofertadas: {} },
    area: { estoque: {}, vendidas: {}, ofertadas: {} },
    cidades: { estoque: {}, vendidas: {}, ofertadas: {} },
  });

  const [indicadoresData, setIndicadoresData] = useState<IndicadoresDashboardDetalhado>({
    cidades: 0,
    construtoras: 0,
    empreendimentos: 0,
    unidades: 0,
    vso: 0,
  });

  const handleFiltrar = (novosFiltros: any) => {
    setFiltros(novosFiltros);
  };

  const numeroVendidos = 45.621;
  const numeroRestantes = 400;

  const indicadoresSecundarios = [
    { title: 'Cidades Mapeadas', value: indicadoresData.cidades.toString(), icon: <MapPin size={'1.4vw'} /> },
    { title: 'Construtoras', value: indicadoresData.construtoras.toString(), icon: <Hammer size={'1.4vw'} /> },
    { title: 'Empreendimentos', value: indicadoresData.empreendimentos.toString(), icon: <Building2 size={'1.4vw'} /> },
    { title: 'Unidades', value: indicadoresData.unidades.toString(), icon: <Building size={'1.4vw'} /> },
    { title: 'VSO', value: `${indicadoresData.vso}%`, icon: <BriefcaseBusiness size={'1.4vw'} /> },
  ];

  useEffect(() => {
    const carregarSegmentos = async () => {
      try {
        const perfil = await authService.getProfile();
        
        // Verifica acessos
        const acessosPlano = perfil?.assinante_membership?.plano?.acessos 
          ?? perfil?.empresa_membership?.plano?.acessos 
          ?? [];

        const podeVerRelatorio = acessosPlano.includes("RELATORIO_PDF");
        setMostrarBotaoRelatorio(podeVerRelatorio);

        // Mantém sua lógica atual para planos
        const segmentosObj = perfil?.empresa_membership?.segmentos_acesso ?? [];
        const isPlano = (seg: string): seg is Plano =>
          ["casa_apartamento", "compacto", "comercial", "lote"].includes(seg);

        const segmentosPlano: Plano[] = segmentosObj.filter(isPlano);
        setPlanosDisponiveis(segmentosPlano);
        setPlanosSelecionados(segmentosPlano);

      } catch (err) {
        console.error("Erro ao carregar segmentos:", err);
      }
    };

    carregarSegmentos();
  }, []);

  // --- DEMAIS USEEFFECTS (sem alterações) ---
  useEffect(() => {
    const carregarDashboard = async () => {
      try {
        const vgv = await getVGVDashboard(filtros);
        setVgvData(vgv);
      } catch {
        setVgvData([]);
      }

      try {
        const estoqueTipo = await getEstoquePorTipo(filtros);
        setEstoquePorTipo(estoqueTipo);
      } catch {
        setEstoquePorTipo({ Lote: 0, Apartamento: 0, Comercial: 0, Casa: 0, Compacto: 0 });
      }

      try {
        const estoqueFase = await getEstoquePorFase(filtros);
        setEstoquePorFase(estoqueFase);
      } catch {
        setEstoquePorFase({ Planta: 0, Obra: 0, Pronto: 0 });
      }

      try {
        const vendido = await getPercentualVendido(filtros);
        setVendidoData(vendido);
      } catch {
        setVendidoData([]);
      }

      try {
        const area = await getIntervalosArea(filtros);
        setAreaData(area);
      } catch {
        setAreaData([]);
      }

      try {
        const precoVendas = await getPrecoMedioM2PorIntervaloVendas(filtros);
        setPrecoM2VendasData(precoVendas);
      } catch {
        setPrecoM2VendasData([]);
      }

      try {
        const precoArea = await getPrecoMedioM2PorIntervaloArea(filtros);
        setPrecoM2AreaData(precoArea);
      } catch {
        setPrecoM2AreaData([]);
      }

      try {
        const precoMes = await getPrecoMedioPorMes(filtros);
        setPrecoMedioData(precoMes);
      } catch {
        setPrecoMedioData([]);
      }

      try {
        const precoM2Mes = await getPrecoMedioM2PorMes(filtros);
        setPrecoMedioM2Data(precoM2Mes);
      } catch {
        setPrecoMedioM2Data([]);
      }

      try {
        const evolucao = await getEvolucaoVendas(filtros);
        setEvolucaoVendasData(evolucao);
      } catch {
        setEvolucaoVendasData([]);
      }

      try {
        const categorias = await getItensPorCategoria(filtros);
        setLazerData(categorias.Lazer.map(i => ({ nome: i.item, valor: i.quantidade })));
        setInfraestruturaData(categorias.Infraestrutura.map(i => ({ nome: i.item, valor: i.quantidade })));
        setSegurancaData(categorias.Segurança.map(i => ({ nome: i.item, valor: i.quantidade })));
      } catch {
        setLazerData([]);
        setInfraestruturaData([]);
        setSegurancaData([]);
      }

      try {
        const unidades = await getUnidadesDashboard(filtros);
        setUnidadesData(unidades);
      } catch {
        setUnidadesData({
          tipologia: { estoque: {}, vendidas: {}, ofertadas: {} },
          area: { estoque: {}, vendidas: {}, ofertadas: {} },
          cidades: { estoque: {}, vendidas: {}, ofertadas: {} },
        });
      }

      try {
        const indicadores = await getIndicadoresDashboardDetalhado(filtros);
        setIndicadoresData(indicadores);
      } catch {
        setIndicadoresData({ cidades: 0, construtoras: 0, empreendimentos: 0, unidades: 0, vso: 0 });
      }

    };

    carregarDashboard();
  }, [filtros]);


  return (
    <div style={{ display: 'flex' }} >
      <Sidebar />
      <div style={{ padding: 20, background: '#f5f5f5', minHeight: '100vh', flex: 1 }}>
        
        <PlanoSelector 
          onChange={setPlanosSelecionados}
          planosDisponiveis={planosDisponiveis}
          planosSelecionados={planosSelecionados}
        />

        <FiltrosDashboard
          planosSelecionados={planosSelecionados}
          onFiltrar={handleFiltrar}
          mostrarBotaoRelatorio={mostrarBotaoRelatorio}
        />

        {/* Conteúdo restante sem alterações */}
        <div className="pdf-slide" >
          <div className="indicadores-secundarios" style={{ marginTop: 20 }}>
            <div className="indicadores-grid-secondary">
              {indicadoresSecundarios.map((item, index) => (
                <CardIndicatorSecondary
                  key={index}
                  value={item.value}
                  title={item.title}
                  icon={item.icon}
                />
              ))}
            </div>
          </div>

          <div className="pdf-slide"> 
            <div className="graficos-principais-dashboard">
              <div className="grafico">
                {vgvData.length > 0 ? (
                  <VGVDashboard dados={vgvData} />
                ) : (
                  <p>Carregando VGV...</p>
                )}
              </div>
            
              <div className="grafico">
                <GaugeDashboard 
                  title="Índice de velocidade de vendas (IVV)" 
                  value={indicadoresData.vso} 
                  vendidos={numeroVendidos} 
                  restantes={numeroRestantes} 
                />
              </div>
            </div>
          </div>
        </div>

        <div className="pdf-slide" >
          <div className="graficos-principais-dashboard">
            <div className="grafico">
              <ProdutoDashboard 
                planosSelecionados={planosSelecionados} 
                dadosEstoque={estoquePorTipo} 
              />
            </div>

            <div className="grafico">
              <FaseDashboard dados={estoquePorFase} />
            </div>
          </div>
        </div>

        <div className="pdf-slide" >
          <div className="graficos-principais-dashboard">
            <div className="grafico">
              <BarLateralIntervalos
                titulo="Intervalos de % vendido"
                dados={vendidoData}
                infoText="Gráfico mostrando a quantidade de empreendimentos por intervalo de % vendido (10 em 10%)."
              />
            </div>

            <div className="grafico">
              <BarLateralIntervalos
                titulo="Intervalos de área"
                dados={areaData}
                infoText="Gráfico mostrando a quantidade de empreendimentos por intervalo de área (50m² em 50m²)."
              />
            </div>
          </div>
        </div>

        <div className="pdf-slide" >
          <div style={{ width: '100%', marginTop: 20 }}>
            <CardUnidades 
              planoUsuario={planosSelecionados[0] as any} 
              unidadesData={unidadesData} 
            />
          </div>
        </div>

        <div className="pdf-slide" >
          <div className="graficos-principais-dashboard">
            <EvolucaoDashboard dados={evolucaoVendasData} />
          </div>
        </div>

        <div className="pdf-slide" >
          <div className="graficos-principais-dashboard">
            <div className="grafico">
              <GraficoBar 
                titulo="Preço médio"
                dados={precoMedioData}
                dataKey="valor"
                infoText="Este gráfico mostra o preço médio do m² por cidade."
              />
            </div>

            <div className="grafico">
              <GraficoBar
                titulo="Preço médio do m²"
                dados={precoMedioM2Data}
                dataKey="valor"
                corBarra="#32BEF0"
                infoText="Este gráfico mostra o preço médio do m² por cidade."
              />
            </div>
          </div>
        </div>

        <div className="pdf-slide" >
          <div className="graficos-principais-dashboard">
            <div className="grafico">
              <BarLateralIntervalos
                titulo="Preço médio do m² por intervalo de vendas"
                dados={precoM2VendasData}
                infoText="Gráfico mostrando a quantidade de empreendimentos por intervalo de % vendido (10 em 10%)."
              />
            </div>

            <div className="grafico">
              <BarLateralIntervalos
                titulo="Preço médio do m² por intervalos de área"
                dados={precoM2AreaData}
                infoText="Gráfico mostrando a quantidade de empreendimentos por intervalo de área (50m² em 50m²)."
              />
            </div>
          </div>
        </div>

        <div className="pdf-slide" >
          <div className="graficos-principais-dashboard-ranking">
            <div className="grafico">
              <CardRanking titulo="Lazer" dados={lazerData} />
            </div>

            <div className="grafico">
              <CardRanking titulo="Infraestrutura" dados={infraestruturaData} />
            </div>

            <div className="grafico">
              <CardRanking titulo="Segurança" dados={segurancaData} />
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
